let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ku7cn")).then(() => parcelRequire('3sPDc'));